import { Component } from 'preact';
import { connect } from 'unistore/preact';
import { locale } from '../../utils/i18n';
import { callPolling, upiAppImgName } from '../../controllers/upi';
import { getKey, staticPath } from '../../utils/common';
import CONSTANT, { CACHE } from '../../utils/constants';

class UpiPolling extends Component {
  constructor(props) {
    super(props);

    const merchantConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
    let merchantDetails = {};
    if (typeof this.props.cache.getData(CACHE.PAYMENT_OPTIONS) === 'object') {
      const paymentOptions = this.props.cache.getData(CACHE.PAYMENT_OPTIONS);
      merchantDetails = paymentOptions.merchantDetails || {};
      // setting name and logo from merchant config  if it exists instead from api
      const merchantName = getKey(merchantConfig, 'merchant.name', null);
      const merchantLogo = getKey(merchantConfig, 'merchant.logo', null);
      merchantDetails.name =
        merchantName || merchantDetails.merchantDisplayName || merchantDetails.merchantName;
      merchantDetails.logo = merchantLogo || merchantDetails.merchantLogo;
    }
    this.setTimeoutIntervalId = '';
    this.timeExp = parseInt(this.props.pollingData.STATUS_TIMEOUT, 10);
    this.timeInMin = this.timeExp / 60000;
    this.state = {
      minLeft: this.timeInMin < 10 ? `0${this.timeInMin}` : this.timeInMin,
      secLeft: '00',
      showInfo: false,
      upiMessage: locale('upi.polling.click'),
      paymodeTxnAmount: this.props.cache.getData(CONSTANT.TXN_AMOUNT),
      merchantDetails,
      ...upiAppImgName(this.props.pollingData.vpaID)
    };
  }

  componentDidMount() {
    const timeOut = parseInt(this.props.pollingData.STATUS_TIMEOUT, 10);
    const timeInterval = parseInt(this.props.pollingData.STATUS_INTERVAL, 10);

    this.setState(upiAppImgName(getKey(this.props, 'pollingData.vpaID', '')));

    this.props.cache.setData(CONSTANT.IS_IN_POLLING_STATUS, true);

    // start timer for polling
    this.updateTimeCount();

    // call polling
    callPolling(timeOut, timeInterval, this.props.cache);
  }

  updateTimeCount() {
    let totalTime = this.timeExp / 1000; // convert ms to sec
    this.setTimeoutIntervalId = setInterval(() => {
      const calcMins = parseInt(totalTime / 60, 10);
      const calcSecs = parseInt(totalTime % 60, 10);

      this.setState({
        minLeft: calcMins < 10 ? `0${calcMins}` : calcMins,
        secLeft: calcSecs < 10 ? `0${calcSecs}` : calcSecs
      });
      totalTime -= 1;
      if (totalTime < 0) {
        clearInterval(this.setTimeoutIntervalId);
      }
    }, 1000);
  }

  toggleInfo() {
    this.setState({ showInfo: !this.state.showInfo });
  }

  componentWillUnmount() {
    clearInterval(this.setTimeoutIntervalId);
  }

  render(
    { pollingData },
    { showInfo, minLeft, secLeft, appName, imageName, paymodeTxnAmount, merchantDetails }
  ) {
    return (
      <section className={`ptm-search-module  ptm-upi-visible`}>
        <div class={`ptm-s-inner ptm-h100 ptm-body-bg`}>
          <div className="ptm-h100">
            <div
              className={`ptm-main-wrapper ptm-upipolling-global ptm-w100 ptm-h100 ptm-auto-overflow`}
            >
              <div className={`ptm-payment-wrapper ptm-w100 ptm-pos-r`}>
                <div className={`ptm-payment-top ptm-upipolling-top-global ptm-w100 ptm-pos-r`}>
                  {merchantDetails && merchantDetails.logo && (
                    <div className={`ptm-upi-merc ptm-pos-r`}>
                      <img
                        className={`ptm-upi-merc-img ptm-pos-a`}
                        src={merchantDetails.logo}
                        alt=""
                      />
                    </div>
                  )}
                  {merchantDetails && merchantDetails.name && (
                    <span
                      className={`ptm-provider ptm-sub-txt-header-global ptm-semibold ptm-ellipsis`}
                    >
                      {merchantDetails.name}
                    </span>
                  )}
                  <span className={`ptm-polling-amount ptm-sub-txt-header-global ptm-semibold`}>
                    &#x20B9; {paymodeTxnAmount}
                  </span>
                </div>
                <div className={`ptm-payment-bottom ptm-poll-bottom ptm-w100`}>
                  <h2 className="ptm-bold ptm-body-color">Complete your Payment</h2>
                  <div class={`ptm-upi-para ptm-pos-r ptm-fs15`}>
                    <span class={`ptm-elip-control ptm-sub-txt-global ptm-ellipsis ptm-body-color`}>
                      Entered UPI Address: {pollingData.vpaID}
                    </span>
                    <span
                      onclick={e => this.toggleInfo(e)}
                      className={`${showInfo ? 'ptm-info-wrapper' : ''} ptm-info-wraper-after`}
                    >
                      <img
                        className={`ptm-info-wrap ptm-pos-r`}
                        src={`${staticPath()}/assets/images/info.png`}
                      />
                    </span>
                    {showInfo && (
                      <div
                        className={`ptm-info-tab
                        ptm-sub-txt-global ptm-fs12 ptm-pos-a`}
                      >
                        {locale('upi.polling.click')}
                      </div>
                    )}
                  </div>
                  <div class={`ptm-steps-wrap`}>
                    <div
                      class={`ptm-upi-steps ptm-upi-steps-global ptm-pos-r ptm-steps-min-height`}
                    >
                      <p class={`ptm-upi-dscr ptm-semibold ptm-sub-txt-global ptm-body-color`}>
                        Go to the {appName}
                      </p>
                      <img
                        class={`ptm-upipolling-img ptm-pos-a`}
                        src={`${staticPath()}/assets/images/${imageName}`}
                        alt="bank app"
                      />
                    </div>
                    <div
                      class={`ptm-upi-steps ptm-upi-steps-global ptm-pos-r ptm-steps-min-height`}
                    >
                      <p class={`ptm-upi-dscr ptm-semibold ptm-sub-txt-global ptm-body-color`}>
                        {locale(`upi.polling.approve`)}
                      </p>
                      <img
                        class={`ptm-upipolling-img ptm-pos-a`}
                        src={`${staticPath()}/assets/images/step-2.png`}
                        alt="bank app"
                      />
                    </div>
                  </div>
                </div>
                <div className={`ptm-timer-wrap ptm-sub-txt-global ptm-w100 paytm-txt-center`}>
                  <h5 className="ptm-fs11 paytm-txt-center ptm-body-color">REQUEST EXPIRES IN</h5>
                  <div className={`ptm-timer ptm-timer-global`}>
                    <div
                      className={`ptm-block ptm-timer-block-global ptm-fs-15 ptm-bold ptm-pos-r paytm-txt-center`}
                    >
                      {minLeft}
                      <p className="ptm-fs11 paytm-txt-center">MIN</p>
                    </div>
                    <div className={`ptm-block ptm-timer-block-global paytm-txt-center`}>
                      {secLeft}
                      <p className="ptm-fs11 paytm-txt-center">SEC</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p
              className={`ptm-instruction ptm-black-global ptm-w100 ptm-fs12 paytm-txt-center ptm-pos-a`}
            >
              {locale('upi.polling.noback')}
            </p>
          </div>
        </div>
      </section>
    );
  }
}

export default connect('cache')(UpiPolling);



// WEBPACK FOOTER //
// ./components/upipolling/index.js